export const LEARN_BTN_CLICK_EVENT = "home_learn_btn_click";
export const JOIN_BTN_CLICK_EVENT = "home_join_btn_click";
